module.exports = __webpack_public_path__ + "img/course data-no-text.c07a15c7.svg";